<template>
  <v-card-text class="terms-text">
    <v-img src="/img/terms_img_area.svg" />
    <p class="pt-10 pb-3">
      BEFORE YOU START USING ANY OF OUR PEPPER BUSINESS SOLUTIONS, PLEASE READ
      THE TERMS AND CONDITIONS OF OUR SELF-SERVE ADVERTISING AND EDITORIAL
      SERVICE. IF YOU DO NOT ACCEPT THESE TERMS AND CONDITIONS, PLEASE DO NOT
      PROCEED FURTHER AND/OR DO NOT CLICK ON A BUTTON INDICATING YOUR
      ACCEPTANCE.
    </p>

    <hr />

    <h1 style="margin: 6px 0 60px 0; font-weight: 400">
      Self-Serve Advertising Terms & Conditions
    </h1>
    <p class="pb-4">
      The following Terms and Conditions ("Self-Serve Advertising Terms and
      Conditions" or "Self-Serve Ads Terms and Conditions") apply to your use of
      the Pepper Business platform to create, submit and / or deliver any
      promotional or other commercial or sponsored activity or content
      (collectively the "Promoted Ads") and for any order you place through the
      platform ("Order").
    </p>

    <hr />

    <h3 class="pt-8 pb-4">1. Definitions.</h3>
    <p><b>“We”</b>: Pepper and its affiliates.</p>
    <p>
      <b>“Pepper Platform”</b>: "Any of the websites and apps operated by Pepper
      (Pepper, mydealz, hotukdeals, Dealabs, Promodescuentos, Preisåjäger)."
    </p>
    <p>
      <b>“Promoted Ad”, “Ad”, “Advertisements”, “Advertising”</b>: Any deal,
      promotional or other commercial or sponsored activity promoted in an Ad
      Slot.
    </p>
    <p><b>“Order”</b>: Any Promoted Ad booked through the platform.</p>
    <p>
      <b>“Ad Slot”, “Advertising space”</b>: Pre-defined and fixed placement in
      a listing page of the Pepper Platform, where an Ad is displayed.
    </p>
    <p>
      <b>“Ad Impression”, “Impression”</b>: The number of times an Ad is
      displayed and seen in an Ad Slot of any Pepper Platform.
    </p>
    <p>
      <b>“Organic Impression”</b>: The number of times a deal is displayed in a
      listing page of any Pepper Platform, outside of an Ad Slot.
    </p>
    <p>
      <b>“Billing account”</b>: Represents the organisation (and its legal
      information) that will be charged for the orders placed through the
      platform.
    </p>
    <p>
      <b>“Advertising account”</b>: The account of the organisation and all the
      individual ones connected to it, that can be used to place orders through
      the platform.
    </p>
    <p>
      <b>“Confidential Information”</b>: Any information disclosed by one party
      to the other, either directly or indirectly, in writing, orally, or by
      inspection of tangible objects, other than information that the receiving
      party can establish: was publicly known and made generally available in
      the public domain prior to the time of disclosure; becomes publicly known
      and made generally available after disclosure other than through the
      receiving party’s action or inaction; or is in the receiving party’s
      possession, without confidentiality restrictions, prior to the time of
      disclosure, as shown by the receiving party’s files and records.
    </p>
    <p>
      <b>“Representative”</b>: Any affiliate network, advertising agency, or
      another entity representing advertisers to order ads on their behalf.
    </p>

    <h3 class="pt-4 pb-4">2. Self-serve use.</h3>
    <p>
      We provide you with access to our Self-Serve Ads platform for Promoted
      Ads. You will pay for all impressions, transactions and/or clicks on your
      ads that we deliver, as stated in your online account. Promoted Ads are
      displayed on a space-available basis and are not guaranteed to appear on
      the Pepper Platform.
    </p>

    <h3 class="pt-4 pb-1">3. Placement of Ads.</h3>
    <h4 class="pb-4">a. Ordering a Promoted Ad.</h4>
    <p>
      You can select your desired Pepper Platform when ordering Promoted Ads so
      that they can be served to the right audience.
    </p>
    <p>
      When placing your order, you select the deal(s) you want to promote, the
      listing in which your Promoted Ad will be displayed, the start date and
      end date as well as the start time and end time of the Promoted Ad, and
      the number of impressions you want to receive (i.e. the number of times
      your deal(s) will be displayed to users), which directly impacts the
      amount you spend. If we accept your order, we will deliver your
      advertisements as soon as advertising space becomes available.
    </p>
    <p>
      Your advertisements must comply with all applicable laws, regulations and
      guidelines. Failure to comply can lead to a variety of consequences,
      including cancelling the ads you run and terminating your account.
    </p>
    <h4 class="pb-4">b. Ad Delivery.</h4>
    <p>
      When delivering your advertisement, we will position your selected deal(s)
      in any of our ads slots in the chosen listing. This will not have any
      influence on the organic impressions received in any of the relevant
      listing(s) of the Pepper Platform. We determine the size and positioning
      of your advertisements and the scheduling of the delivery depends on the
      availability and may not be continuous. We will do our best to deliver the
      number of impressions you have selected.
    </p>
    <p>
      We do not guarantee reach or performance for your advertisements, such as
      for example, the number of people who will see your ads or the number of
      clicks they will get.
    </p>
    <p>
      We cannot control how clicks are generated for your ads. We use systems
      that try to identify and filter certain click activities. However, we are
      not responsible for click fraud, technical problems, or other potentially
      invalid click activity that could affect the cost of serving ads.
    </p>
    <p>
      We also offer tools to inform our users about how advertising works on
      Pepper and how to control it. These tools may affect your ability to serve
      these users or prevent them from seeing your advertisements.
    </p>
    <p>
      Our licence to serve your ad ends when we have completed your assignment.
      However, you are aware that:
    </p>
    <ul class="pb-4">
      <li>
        The content that was the object of the advertisement can still be
        accessed on the relevant Pepper Platform, from the different deal and
        voucher listings.
      </li>
      <li>
        The ad may still persist on our products once users have interacted with
        it.
      </li>
    </ul>
    <p>
      From time to time we need to test improvements to our target audiences and
      delivery systems, which could affect your advertising. With the help of
      these tests, we want to improve the effectiveness of your ad performance.
      We reserve the right to conduct tests if we believe they are beneficial to
      the advertiser's performance.
    </p>
    <h4 class="pb-4">c. Pausing, stopping or cancelling an order.</h4>
    <p>
      You can pause, stop or cancel an order at any time. However, your ads may
      still be displayed for 24 hours after you let us know. In this case, you
      are still responsible for paying for all advertisements that appear.
    </p>
    <p>
      We may automatically stop delivering your ads in the event where the
      promoted content is no longer available, for any reason.
    </p>

    <h3 class="pt-4 pb-1">4. Charges, fees, payment and taxes.</h3>
    <h4 class="pb-4">a. Billing account.</h4>
    <p>
      To place orders you must have activated and linked an approved billing
      account to your advertiser account or chosen to pay through a designated
      affiliate network, subject to our acceptance, as part of the onboarding
      process.
    </p>
    <p>
      By creating a billing account, you authorize us to obtain your personal
      and/or business credit report from a credit reporting agency either at the
      time you place your order or at any time thereafter.
    </p>
    <p>
      You guarantee that the information and data you provide as part of the
      setup of your billing account is correct and remains correct until you
      update your existing billing account or create a new billing account
      (required for each separate legal entity).
    </p>
    <p>
      We will automatically review your billing account information prior to
      approving the billing account details. We may reject your billing account
      information should the information appear to be incorrect during the
      account creation process or close your billing account at any time if it
      becomes clear that the information provided in your billing account is
      incorrect.
    </p>
    <p>
      If you cancel your billing account or your billing account is cancelled by
      Pepper you will not be able to book future advertisements with Pepper
      until a new billing account is created and linked to your advertising
      account on Pepper Business. All existing advertisements not yet billed
      will be billed to the cancelled billing account details at the end of the
      billing cycle.
    </p>
    <h4 class="pb-4">b. Payment and taxes.</h4>
    <p>
      You will pay for all impressions, transactions and/or clicks on your ads
      that we deliver. You will not be charged for organic impressions.
      Transactions and/or clicks are being charged for separately, and are
      subject to the Editorial Service Terms & Conditions.
    </p>
    <p>
      You will pay all amounts stated in each individual order you place as well
      as any applicable taxes. The amount you owe for each order is calculated
      on the basis of the number of delivered ad impressions, measured through
      our tracking mechanisms.
    </p>
    <p>
      You are responsible for maintaining the security of your advertising
      account and understand that you will be billed for any orders placed on or
      through your advertising account.
    </p>
    <p>
      The amounts that we will invoice you may be subject to taxes and duties
      and include the corresponding amounts due, such as withholding taxes. You
      are responsible for bearing and paying any taxes applicable to your
      transactions. You release us from any claim that arises from your failure
      to do so and hold us harmless.
    </p>
    <p>
      If your payment method fails or your account is overdue, we may take
      additional measures to collect any overdue amounts. You agree to pay all
      costs associated with such collection, including reasonable legal fees.
      Overdue amounts accrue interest of 1% per month or the legally permitted
      maximum, whichever is lower.
    </p>

    <h4 class="pb-4">c. Payment methods.</h4>
    <p>
      Depending on your payment method, you belong to one of two categories:
      customer with invoice if you have set up a billing account or customer
      without invoice if you have chosen to pay through a designated affiliate
      network, which is subject to our acceptance.
    </p>
    <p>
      If you are a customer with an invoice, we set a maximum spending limit on
      your advertiser account and you will regularly receive invoices for
      payment in accordance with the applicable billing conditions. You will pay
      all undisputed charges in full within thirty (30) calendar days of the
      invoice date unless otherwise specified.
    </p>
    <p>
      If you are a customer without invoice, you are responsible for ensuring
      the payment is made by your designated affiliate network within thirty
      (30) calendar days from the creation of the monthly advertising report
      from Pepper Business which will detail the amount due.
    </p>
    <p>
      In both cases, failure to make payment within 30 days may result in your
      advertiser account being temporarily suspended or permanently terminated.
      If you are a customer without invoice, the option to pay through a
      designated affiliate network may also be removed. Should this occur, we
      have the right to directly invoice you for all outstanding invoices.
    </p>

    <h3 class="pt-8 pb-4">5. Performance reports.</h3>
    <p>
      We will provide you with reports that will allow you to assess the
      performance of your ads. These reports contain information about the
      number of impressions and clicks your ads received, measured through our
      tracking mechanisms. You are responsible for tracking any other metric you
      deem necessary.
    </p>

    <h3 class="pt-8 pb-4">6. Relationship.</h3>
    <p>
      We will provide you with reports that will allow you to assess the
      performance of your ads. These reports contain information about the
      number of impressions and clicks your You and we are independent
      contractors and nothing will be construed to create, evidence, or imply
      any agency, employment, partnership, or joint venture between you and us.
      Except as otherwise set forth in these Terms and Conditions, neither you
      nor we will have any right, power, or authority to create any obligation
      or responsibility on behalf of the other and these Terms and Conditions
      are not intended to benefit, nor will it be deemed to give rise to any
      rights in, any third party. Notwithstanding the foregoing, you acknowledge
      and agree that we will be third-party beneficiaries to these Terms and
      Conditions and will be entitled to directly enforce, and rely upon, any
      provision in these terms, which confers a benefit on, or rights in favour
      of, them.ads received, measured through our tracking mechanisms. You are
      responsible for tracking any other metric you deem necessary.
    </p>

    <h3 class="pt-8 pb-4">7. Confidentiality.</h3>
    <p>
      You and we agree that each party shall treat confidentially all
      information provided by each party to the other regarding its business and
      operations. All confidential information provided by a party shall be used
      by any other party solely for the purpose of rendering or obtaining
      services pursuant to these Terms and Conditions and, except as may be
      required in carrying out these Terms and Conditions, shall not be
      disclosed to any third party without the prior consent of such providing
      party.
    </p>
    <p>
      The receiving party will take all measures to protect the secrecy of, and
      to avoid disclosure and unauthorized use of, confidential information. If
      required by law to disclose confidential information, the receiving party
      may do so provided that:
    </p>
    <p class="pl-4">
      1. The receiving party gives the disclosing party prompt written notice of
      such requirement prior to such disclosure.
    </p>
    <p class="pl-4">
      2. At the disclosing party’s request, the receiving party assists the
      disclosing party in obtaining an order protecting the confidential
      information from public disclosure.
    </p>
    <p class="pl-4">
      3. Any such disclosure is limited to the minimum extent necessary to
      comply with the legal requirement.
    </p>
    <p>
      Neither you nor us may issue any press release or other public statement
      regarding the relationship created under these Terms and Conditions
      without the other’s prior written consent, except that we may use your
      trademarks, logos or other indicia of origin associated with you solely
      for the purpose of indicating that you are a client of Pepper. Except as
      set forth herein, upon expiration or termination of the Terms and
      Conditions, or upon the reasonable request of either party, the receiving
      party shall promptly return or destroy all confidential information of the
      other party and any copies of the confidential information of the other
      party to its owner.
    </p>
    <p>
      We may, at our sole discretion and upon your acceptance, provide you with
      early access to non-generally available alphas, betas, research studies,
      pilots, marketing services and/or other programs, which are all considered
      confidential information. You agree that participating in any of these
      experiments means you will assist us in researching, analyzing and
      validating some existing and/or prospective programs, products and/or
      tools, and that if you provide us with any comments, feedback or other
      information to assist us in evaluating and improving such programs,
      products and/or tools, we will be free to use the information you provided
      now or in the future in any way without any compensation or obligation to
      you or any third party.
    </p>

    <h3 class="pt-4 pb-1">8. Representative.</h3>
    <h4 class="pb-4">a. Representative obligations.</h4>
    <p>
      If you are an affiliate network, advertising agency, or another entity
      representing advertisers to order ads on their behalf (“Representative”),
      you must have permission to order those ads and you agree to the
      following:
    </p>
    <p class="pl-4">
      1. You represent and warrant that you are authorized to bind the
      advertiser to these Self-Serve Ads Terms and Conditions as well as the
      Pepper Platform Terms of Conditions. You also agree with them.
    </p>
    <p class="pl-4">
      2. If the advertiser you represent violates these Self-Serve Ads Terms and
      Conditions, the Pepper Platform Terms of Conditions, we may hold you
      responsible for the violation.
    </p>
    <p class="pl-4">
      3. You agree that we can provide reporting information about the
      advertisement(s) to the end advertiser for whom you have run them.
    </p>
    <h4 class="pb-4">b. Liability.</h4>
    <p>
      Unless otherwise agreed upon in writing between or among Representative or
      Advertiser, on the one hand, and us, on the other hand, and to the fullest
      extent permitted by law, Representative and each Advertiser will be
      jointly and severally liable for all payment obligations pursuant to
      Section 4 above, and you hereby waive any right under the Laws that may
      require us to proceed against one or more of you prior to proceeding
      against any others who may also be liable, and we will not release you
      from liability even if a sequential liability clause is included in any
      contract, insertion order, purchase order, or other correspondence from
      you or Advertiser.
    </p>

    <h3 class="pt-4 pb-1">9. Contracting party.</h3>
    <p>
      The table below defines, based on which platform of Pepper you choose to
      advertise on, the Pepper company providing you with the user-interfaces
      for self-service ads.
    </p>
    <table>
      <tr>
        <th>Country</th>
        <th>Platform</th>
        <th>Pepper Company</th>
      </tr>
      <tr>
        <td>Germany</td>
        <td>mydealz.de</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Poland</td>
        <td>pepper.pl</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>The Netherlands</td>
        <td>nl.pepper.com</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Russia</td>
        <td>pepper.ru</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Austria</td>
        <td>preisjaeger.at</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Great Britain</td>
        <td>pepper.com</td>
        <td>Pepper Deals Ltd</td>
      </tr>
      <tr>
        <td>France</td>
        <td>pepper.com</td>
        <td>Pepper France SASU</td>
      </tr>
      <tr>
        <td>Mexico</td>
        <td>pepper.com</td>
        <td>Jalapeno Media Ltd</td>
      </tr>
      <tr>
        <td>Italy</td>
        <td>pepper.com</td>
        <td>Pepper Italy GmbH</td>
      </tr>
      <tr>
        <td>Brazil</td>
        <td>pelando.com.br</td>
        <td>Pelando Portal Virtual SA</td>
      </tr>
    </table>

    <h3 class="pt-4 pb-1">10. Other.</h3>
    <p>
      We may ask you to read through and accept additional Terms and Conditions
      or agreements that apply to your use of a certain feature or functionality
      that is made available via the user interfaces for self-serve ads. If
      there is any contradiction between such additional Terms and Conditions or
      agreements and these Terms and Conditions, the additional Terms and
      Conditions or agreements apply with regard to your use of the specific
      function or functionality to the extent of the objection. We may change or
      update these Terms and Conditions from time to time. If you continue to
      use the self-serve ad user interfaces afterwards, this constitutes your
      acceptance of such changes.
    </p>

    <h3 class="pt-4 pb-1">11. Termination.</h3>
    <p class="pb-10">
      At any time, for any or no reason, you or we may terminate the Terms and
      Conditions. At any time, and at our sole discretion, we may update or
      modify any features or functionality, or the Self-Serve Ads Terms and
      Conditions. Subject to applicable law, we may also, at our sole
      discretion, terminate or suspend or limit your use of our Self-Serve Ads
      platform or part thereof, including suspending or removing your ads. We
      will have no liability regarding the foregoing decisions. Upon termination
      of any Terms and Conditions or the suspension or discontinuation of your
      participation therein, your outstanding payment obligations incurred will
      become immediately due and payable. Sections 4, 6, 7, 9 will survive
      termination of the Terms and Conditions.
    </p>

    <h1 class="pt-10">Editorial Service Terms & Conditions</h1>
    <p>
      The following Terms and Conditions ("Editorial Service Terms and
      Conditions") apply to your use of the Pepper Business platform to create
      and submit for review any promotional offer or other commercial campaign
      or content (collectively the "Deals").
    </p>

    <hr />

    <h3 class="pt-10 pb-4">1. Definitions.</h3>
    <p><b>“We”</b>: Pepper and its affiliates.</p>
    <p>
      <b>“Pepper Platform”</b>: Any of the websites and apps operated by Pepper
      (Pepper, mydealz, hotukdeals, Dealabs, Promodescuentos, Preisjäger).
    </p>
    <p>
      <b>“Deal”</b>: Any promotional offer or other commercial campaign or
      content submitted for review on Pepper Business.
    </p>
    <p>
      <b>“Editorial deal”</b>: Any promotional offer or other commercial
      campaign or content submitted on the Pepper Platform by a member of the
      editorial team of Pepper.
    </p>
    <p>
      <b>“Community deal”</b>: Any promotional offer or other commercial
      campaign or content submitted on the Pepper Platform by a community
      member.
    </p>
    <p>
      <b>“Discussion thread”</b>: Any content that isn't directly about, but can
      include links or references to, a promotional offer or other commercial
      campaign, submitted on the Pepper Platform by any type of member.
    </p>
    <p>
      <b>“Visitor”</b>: Any person following a link or clicking a button on the
      Pepper Platform redirecting to an external website.
    </p>
    <p>
      <b>“Click out”</b>: Any click made on any of the links and buttons of the
      Pepper Platform that redirects the Visitor to the designated website
      domain name(s) of the Business account, or to the marketplace offers from
      the designated seller ID of the Business account.
    </p>
    <p>
      <b>“Transaction”</b>: The agreed purchase of a product, service or
      equivalent offered by the Business account by a Visitor.
    </p>
    <p>
      <b>“Billing account”</b>: Represents the organisation (and its legal
      information) that will be charged for all delivered click outs.
    </p>
    <p>
      <b>“Business account”</b>: The account of the organisation and all the
      individual ones connected to it, that can be used to submit deals for
      review on the platform.
    </p>

    <h3 class="pt-4 pb-4">2. Editorial service use.</h3>
    <p>
      We provide you with access to our Editorial Service platform for deals.
      Deals you’re submitting for review are not guaranteed to appear on the
      Pepper Platform. You will pay for all click outs or transactions that we
      deliver, as stated in our separate agreements.
    </p>

    <h3 class="pt-4 pb-1">3. Submitting deals for review.</h3>
    <h4 class="pb-4">a. Creating a deal.</h4>
    <p>
      You can select your desired Pepper Platform when creating deals so that
      you can reach the right audience.
    </p>
    <p>
      When creating a deal, you tell us the offer you want us to promote and its
      conditions, including, but not limited to, the price or discount, the
      visual assets, the shipping costs, the eligible products or services, the
      start date and end date, the embargo date.
    </p>
    <p>
      You grant us a non-exclusive, licence fee-free, royalty-free, worldwide
      licence to use, copy, adapt, reformat, recompile, truncate, and/or edit
      any part of the provided materials for public performance, public display,
      and distribution and you hereby waive and agree to procure a waiver of any
      moral rights you or a third party may have in the materials in this
      respect to the maximum extent permitted by law.
    </p>
    <p>
      Your deal must comply with all applicable laws, regulations and
      guidelines. Failure to comply can lead to a variety of consequences,
      including blocking your domain on the Pepper Platform and terminating your
      business account.
    </p>
    <h4 class="pb-4">b. Limits.</h4>
    <p>
      You can only create a limited number of deals per day and week. Any deal
      created by any of the users with access to your business account counts
      towards your limit, whether it’s approved or denied.
    </p>
    <p>
      We reserve the right to adjust the limit of your business account at any
      time for a variety of reasons, including when the approval rate of your
      deals submitted for review decreases, unless we have signed or reached a
      separate agreement entitling you to a specific limit.
    </p>
    <h4 class="pb-4">c. Review process.</h4>
    <p>
      We will review your deals in the shortest possible time. We however do not
      guarantee any maximum review time, unless we have signed or reached a
      separate agreement entitling you to a faster review process for a limited
      period of time. We will let you know about our decision shortly after
      having reviewed your deal.
    </p>
    <p>
      If your deal is approved, it will be submitted on the relevant Pepper
      Platform in due time and we’ll provide you with a link to it. We’ll
      include in our deal all elements that are deemed as important to be
      mentioned, but we can’t guarantee that the ones you communicated will be
      reused.
    </p>
    <p>
      If we’re not able to submit your deal, we’ll make our best efforts to
      provide you with an explanation of the reason(s) preventing us from doing
      so.
    </p>
    <p>
      Our review process can differ from one Pepper Platform to another, we do
      not guarantee similar outcomes for similar deals, submitted for review on
      different Pepper Platforms.
    </p>
    <p>
      Trying to circumvent our review process by submitting a deal on any Pepper
      Platform directly or indirectly (e.g. through an interested party) can
      lead to a variety of consequences, including temporarily or permanently
      blocking your domain or brand on the Pepper Platform and terminating your
      account.
    </p>

    <h3 class="pt-4 pb-1">4. Charges, fees, payment and taxes.</h3>
    <h4 class="pb-4">a. Billing account.</h4>
    <p>
      Submitting deals for review is free of charge provided you have concluded
      a CPC agreement and linked an approved billing account to your advertiser
      account or chosen to pay through an affiliate network.
    </p>
    <p>
      By creating a billing account, you authorize us to obtain your personal
      and/or business credit report from a credit reporting agency either at the
      time you place your order or at any time thereafter.
    </p>
    <p>
      You agree that the information and data you provide as part of the setup
      of your billing account is correct and remains correct until you update
      your existing billing account or create a new billing account (required
      for each separate legal entity).
    </p>
    <p>
      We will automatically review your billing account information prior to
      approving the billing account details. We may reject your billing account
      information should the information appear to be incorrect during the
      account creation process or close your billing account at any time if it
      becomes clear that the information provided in your billing account is
      incorrect.
    </p>
    <p>
      If you cancel your billing account or your billing account is cancelled by
      Pepper you will not be able to submit deals for review until a new billing
      account is created and linked to your account on Pepper Business. All
      existing advertisements not yet billed will be billed to the cancelled
      billing account details at the end of the billing cycle.
    </p>
    <h4 class="pb-4">b. Payment and taxes.</h4>
    <p>
      If you have concluded a CPC agreement with us, you will be charged for all
      click outs resulting from both editorial deals and community deals, as
      well as any discussion thread submitted on the Pepper Platform. As a
      matter of clarification, only the click outs that are redirecting visitors
      from the Pepper Platform to your designated website domain name(s), or to
      the marketplace offers from your designated seller ID / brand will be
      accounted for.
    </p>
    <p>
      If you have chosen to be charged based on delivered transactions, you will
      be charged for all transactions on your designated website domain name(s)
      that are resulting from both editorial deals and community deals, as well
      as any discussion thread submitted on the Pepper Platform. We don’t track
      transactions ourselves. Transactions are being tracked separately by your
      designated affiliate network, which is also in charge of the billing and
      payment conditions, as stated in our separate agreements.
    </p>
    <p>
      <i
      >The following terms are only applicable to customers that have
        concluded a CPC agreement:</i
      >
    </p>
    <p>
      You will pay all amounts stated for the number of delivered click outs as
      well as any applicable taxes. The amount you owe for each order is
      calculated on the basis of our tracking mechanisms.
    </p>
    <p>
      The amounts that we will invoice you may be subject to taxes and duties
      and include the corresponding amounts due, such as withholding taxes. You
      are responsible for bearing and paying any taxes applicable to your
      transactions. You release us from any claim that arises from your failure
      to do so and hold us harmless.
    </p>
    <p>
      If your payment method fails or your account is overdue, we may take
      additional measures to collect any overdue amounts. You agree to pay all
      costs associated with such collection, including reasonable legal fees.
      Overdue amounts accrue interest of 1% per month or the legally permitted
      maximum, whichever is lower.
    </p>
    <h4 class="pb-4">c. Payment methods.</h4>
    <p>
      Depending on your payment method, you belong to one of two categories:
      customer with invoice if you have concluded a CPC agreement or customer
      without invoice if you have chosen to pay through a designated affiliate
      network.
    </p>
    <p>
      If you are a customer with an invoice, you will regularly receive invoices
      for payment in accordance with the applicable billing conditions. You will
      pay all undisputed charges in full within thirty (30) calendar days of the
      invoice date unless otherwise specified.
    </p>
    <p>
      If you are a customer without invoice, you are responsible for ensuring
      the payment is made by your designated affiliate network in due time.
    </p>
    <p>
      In both cases, failure to make payment of issued invoices within 30 days
      may result in your advertiser account being temporarily suspended or
      permanently terminated.
    </p>

    <h3 class="pt-4 pb-4">5. Performance reports.</h3>
    <p>
      <i
      >The following terms are only applicable to customers that have
        concluded a CPC agreement:</i
      >
    </p>
    <p>
      We will provide you with reports that will allow you to monitor the number
      of delivered click outs, measured through our tracking mechanisms. You are
      responsible for tracking any other metric you deem necessary.
    </p>

    <h3 class="pt-4 pb-4">6. Confidentiality.</h3>
    <p>
      You and we agree that each party shall treat confidentially all
      information provided by each party to the other regarding its business and
      operations. All confidential information provided by a party shall be used
      by any other party solely for the purpose of rendering or obtaining
      services pursuant to these Terms and Conditions and, except as may be
      required in carrying out these Terms and Conditions, shall not be
      disclosed to any third party without the prior consent of such providing
      party.
    </p>
    <p>
      The receiving party will take all measures to protect the secrecy of, and
      to avoid disclosure and unauthorized use of, confidential information. If
      required by law to disclose confidential information, the receiving party
      may do so provided that:
    </p>
    <p class="pl-4">
      1. The receiving party gives the disclosing party prompt written notice of
      such requirement prior to such disclosure.
    </p>
    <p class="pl-4">
      2. At the disclosing party’s request, the receiving party assists the
      disclosing party in obtaining an order protecting the confidential
      information from public disclosure.
    </p>
    <p class="pl-4">
      3. Any such disclosure is limited to the minimum extent necessary to
      comply with the legal requirement.
    </p>
    <p>
      Neither you nor us may issue any press release or other public statement
      regarding the relationship created under these Terms and Conditions
      without the other’s prior written consent, except that we may use your
      trademarks, logos or other indicia of origin associated with you solely
      for the purpose of indicating that you are a client of Pepper. Except as
      set forth herein, upon expiration or termination of the Terms and
      Conditions, or upon the reasonable request of either party, the receiving
      party shall promptly return or destroy all confidential information of the
      other party and any copies of the confidential information of the other
      party to its owner.
    </p>
    <p>
      We may, at our sole discretion and upon your acceptance, provide you with
      early access to non-generally available alphas, betas, research studies,
      pilots, marketing services and/or other programs, which are all considered
      confidential information. You agree that participating in any of these
      experiments means you will assist us in researching, analyzing and
      validating some existing and/or prospective programs, products and/or
      tools, and that if you provide us with any comments, feedback or other
      information to assist us in evaluating and improving such programs,
      products and/or tools, we will be free to use the information you provided
      now or in the future in any way without any compensation or obligation to
      you or any third party.
    </p>

    <h3 class="pt-4 pb-1">7. Representative.</h3>
    <h4 class="pb-4">a. Representative obligations.</h4>
    <p>
      If you are an affiliate network, advertising agency, or another entity
      representing advertisers to submit deals for review on their behalf
      (“Representative”), you must have permission to submit these deals for
      review and you agree to the following:
    </p>
    <p class="pl-4">
      1. You represent and warrant that you are authorized to bind the
      advertiser to these Editorial Service Terms and Conditions as well as the
      general Pepper Terms of Conditions. You also agree with them.
    </p>
    <p class="pl-4">
      2. If the advertiser you represent violates these Editorial Service Terms
      and Conditions, the Pepper Platform Terms of Conditions, we may hold you
      responsible for the violation.
    </p>
    <p class="pl-4">
      3. You agree that we can provide reporting information about the deals to
      the end advertiser for whom you have submitted deals for review.
    </p>
    <h4 class="pb-4">b. Liability.</h4>
    <p>
      Unless otherwise agreed upon in writing between or among Representative or
      Advertiser, on the one hand, and us, on the other hand, and to the fullest
      extent permitted by law, Representative and each Advertiser will be
      jointly and severally liable for all payment obligations pursuant to
      Section 4 above, and you hereby waive any right under the Laws that may
      require us to proceed against one or more of you prior to proceeding
      against any others who may also be liable, and we will not release you
      from liability even if a sequential liability clause is included in any
      contract, insertion order, purchase order, or other correspondence from
      you or Advertiser.
    </p>

    <h3 class="pt-4 pb-4">8. Contracting party.</h3>
    <p>
      The table below defines, based on which Pepper Platform you choose to
      submit deals for review, the Pepper company providing you with the
      user-interfaces for editorial service.
    </p>
    <table>
      <tr>
        <th>Country</th>
        <th>Platform</th>
        <th>Pepper Company</th>
      </tr>
      <tr>
        <td>Germany</td>
        <td>mydealz.de</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Poland</td>
        <td>pepper.pl</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>The Netherlands</td>
        <td>nl.pepper.com</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Russia</td>
        <td>pepper.ru</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Austria</td>
        <td>preisjaeger.at</td>
        <td>6 Minutes Media GmbH</td>
      </tr>
      <tr>
        <td>Great Britain</td>
        <td>pepper.com</td>
        <td>Pepper Deals Ltd</td>
      </tr>
      <tr>
        <td>France</td>
        <td>pepper.com</td>
        <td>Pepper France SASU</td>
      </tr>
      <tr>
        <td>Mexico</td>
        <td>pepper.com</td>
        <td>Jalapeno Media Ltd</td>
      </tr>
      <tr>
        <td>Italy</td>
        <td>pepper.com</td>
        <td>Pepper Italy GmbH</td>
      </tr>
      <tr>
        <td>Brazil</td>
        <td>pelando.com.br</td>
        <td>Pelando Portal Virtual SA</td>
      </tr>
    </table>

    <h3 class="pt-4 pb-1">9. Other.</h3>
    <p>
      We may ask you to read through and accept additional Terms and Conditions
      that apply to your use of a certain feature or functionality that is made
      available via the user interfaces for editorial service. If there is any
      contradiction between such additional Terms and Conditions and these
      Editorial Service Terms and Conditions, the additional Terms and
      Conditions apply with regard to your use of the specific function or
      functionality to the extent of the objection. We may change or update
      these Editorial Service Terms and Conditions from time to time. If you
      continue to use the editorial service user interfaces afterwards, this
      constitutes your acceptance of such changes.
    </p>

    <h3 class="pt-4 pb-1">10. Termination.</h3>
    <p>
      At any time, and at our sole discretion, we may update or modify any
      features or functionality, or the Editorial Service Terms and Conditions.
      Subject to applicable law, we may also, at our sole discretion, terminate
      or suspend or limit your use of our Editorial Service platform or part
      thereof, including suspending or removing your deals. We will have no
      liability regarding the foregoing decisions. Upon termination of any Terms
      and Conditions or the suspension or discontinuation of your participation
      therein, your outstanding payment obligations incurred will become
      immediately due and payable. Sections 4, 6, 7, 9 will survive termination
      of the Terms And Conditions.
    </p>
  </v-card-text>
</template>

<script></script>

<style lang="scss">
.terms-text {
  width: 540px;
  height: 696px;
  font-size: 14px;
  line-height: 20px;
  color: #393a4a;
  border: none;

  h1 {
    margin: 20px 0;
    font-size: 24px;
    font-weight: 700;
    color: #18181e;
  }

  h3 {
    font-weight: 700;
    color: #18181e;
  }

  p {
    font-size: 14px;
    text-align: justify;
    color: #393a4a;
  }

  ul {
    list-style-type: none;
    color: #393a4a;
  }

  li::before {
    content: '-';
  }

  table {
    margin: 20px 0;
    border-collapse: collapse;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;

    tr {
      height: 70px;
    }

    th {
      width: 30%;
      padding: 0 10px;
      text-align: left;
      background-color: #f3f3f3;
      border: 1px solid #d9d9d9;
    }

    td {
      padding: 0 10px;
      border: 1px solid #d9d9d9;
    }
  }
}
</style>
